import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core'
import CancelButton from 'app/components/buttons/CancelButton'
import { ButtonWithLoading } from 'app/components/FormsyHelperComponent'
import MessageAlert from 'app/components/MessageAlert'
import { useFormsy } from 'commons/form'
import useFormState, { actionTypes } from 'commons/useFormState'
import Formsy from 'formsy-react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import React, { useEffect, useRef } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import {
  PlanBillingDetailsForm,
  parsePhoneNumber,
} from './PlanBillingDetailsForm'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'

function PlanBillingDetailsFormDialog(props) {
  const { isOpen, onClose, onSubmit, titleId, initialValue = {} } = props
  const formRef = useRef()
  const { formatMessage } = useIntl()
  const { isPristine, onChange } = useFormsy(formRef)
  const reduxDispatch = useDispatch()
  const [formState, dispatch] = useFormState()

  const handleSubmit = async (value) => {
    try {
      dispatch({ type: actionTypes.SUBMIT_INIT })
      await onSubmit(
        R.mergeAll([
          value,
          {
            token: R.prop('token', initialValue),
          },
          parsePhoneNumber(value), //countryCode, phoneNumber
        ]),
      )
    } catch (error) {
      reduxDispatch(MessageAlert.showNetworkError(formatMessage)(error))
    }
    dispatch({ type: actionTypes.SUBMIT_SUCCESS })
  }

  useEffect(() => {
    onChange()
  }, [onChange])

  const handleInvalid = () =>
    dispatch({
      type: actionTypes.INVALID_FORM,
    })

  const handleValid = () =>
    dispatch({
      type: actionTypes.VALID_FORM,
    })

  if (!isOpen) return null

  return (
    <Formsy
      onChange={onChange}
      onValidSubmit={handleSubmit}
      onValid={handleValid}
      onInvalid={handleInvalid}
      className="flex flex-col"
      ref={formRef}
    >
      <ResponsiveDialog
        open={isOpen}
        onClose={onClose}
        scroll="paper"
        fullWidth
        maxWidth="md"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        classes={{ paper: 'overflow-y-visible' }}
      >
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h6">
            <FormattedMessage
              id={titleId || 'planAndBilling.billingDetails.form.title.label'}
            />
          </Typography>
        </DialogTitle>
        <DialogContent
          classes={{
            root: 'p-24 pt-0',
          }}
        >
          <PlanBillingDetailsForm
            initialValue={initialValue}
            formRef={formRef}
            displayTitle={false}
          />
        </DialogContent>
        <DialogActions className="justify-end ltr:pl-16 rtl:pr-16 ltr:pr-24 rtl:pl-24">
          <CancelButton onClick={onClose} className="ltr:mr-16 rtl:ml-16" />
          <ButtonWithLoading
            isLoading={R.prop('isSubmitting', formState)}
            labelId={'action.save'}
            disabled={
              !R.prop('isFormValid', formState) ||
              R.prop('isSubmitting', formState) ||
              isPristine
            }
            onClick={() => handleSubmit(formRef.current.getModel())}
          />
        </DialogActions>
      </ResponsiveDialog>
    </Formsy>
  )
}

PlanBillingDetailsFormDialog.propTypes = {
  titleId: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValue: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    company: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    countryCode: PropTypes.string,
    streetAddress: PropTypes.string,
  }),
}

export default PlanBillingDetailsFormDialog
